<template>
  <div class='card card-login my-auto'>
    <div class='card-header text-center bg-white d-flex flex-column align-items-center justify-content-center'>
      <h4 class='d-none d-sm-block panel-heading flex-1 font-weight-bold' v-html='html.header'></h4>
      <h2 class='d-block d-sm-none panel-heading flex-1 font-weight-bold' v-html='html.header'></h2>
      <h4 class='d-none d-sm-block' v-html='html.body'></h4>
    </div>
    <div class='card-body'>
      <slot></slot>
    </div>
    <div class='card-footer bg-white text-muted d-none d-sm-block' v-html='html.footer || footer'></div>
  </div>
</template>

<script>
export default {
  props: {
    html: {
      default() {
        return {
          header: '',
          body: '',
          footer: '',
        };
      },
      type: Object,
    },
    footer: {
      type: String,
      default: '<h5 class="text-center"><a class="text-white" target="_blank" href="https://forms.monday.com/forms/d49974ca78ed0c60747c16c8e68b4a94"><i class="fa fa-question-circle mr-1"></i>Destek</a></h5>',
    },
  },
  name: 'ActivationForm',
};
</script>

<style lang='scss' scoped>
$primary: rgb(182, 157, 230);
$gradient: #38c172;

.card {
  &>.card-header {

    h2,
    h5 {
      margin: 0;
    }
  }
}

@media (max-width: 680px) {
  .card-login {
    width: 90%;
    margin: 0 auto;
  }
}

@media (max-width: 576px) {
  .card-login {
    width: 100%;
    margin: 0 auto;
  }
}
</style>
